import { isValidElement, type ReactNode } from 'react';

export const isTextNode = (node: ReactNode) => {
  return node != null && !Array.isArray(node) && !isValidElement(node);
};
